export default __webpack_public_path__ + "locales/ja-JP/ChangePortalOwner.json?hash=d40d1a9042caa098725e638438db2afd";